// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__KCsDV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1HNVU"};